module.exports = __webpack_public_path__ + "static/media/2020040414340300-02CB906EA538A35643C1E1484C4B947D.eca8c770.jpg";